import React from 'react';
import './Loading.css';
import Loader from './Loader.svg'; // Ya .gif

const Loading = () => {
  return (
    <div className="loading-overlay">
      <div className="loading-container">
        <img src={Loader} alt="Loading animation" />
      </div>
    </div>
  );
};

export default Loading;
